import { styled } from 'styled-components';
import { COLORS } from '../../../../../styles/style';
import React, { PropsWithChildren } from 'react';

export const SubconfigurationRowStartOrEndStyled = styled.div<{
  $target?: true;
  $highlightTop?: boolean;
  $highlightBottom?: boolean;
}>`
  margin-left: 0;
  margin-right: 0;
  ${p => p.$highlightTop && `border-radius: 0.385rem 0.385rem 0 0; margin-top: 1rem;`}
  ${p => p.$highlightBottom && `border-radius: 0 0 0.385rem 0.385rem; margin-bottom: 0.5rem;`}
  border-top: ${p => (p.$highlightTop ? '1px' : '0')} solid ${COLORS.BORDER};
  border-bottom: ${p => (p.$highlightBottom ? '1px' : '0')} solid ${COLORS.BORDER};
  border-left: 1px solid ${COLORS.BORDER};
  border-right: 1px solid ${COLORS.BORDER};
  background-color: ${COLORS.GREY_LIGHT};
  height: 1rem;
`;

export const SubconfigurationRowStyled = styled.div<{
  $target?: true;
}>`
  margin-left: 0;
  margin-right: 0;
  padding-left: 2.5rem;
  padding-right: 0;
  background-color: ${COLORS.GREY_LIGHT};
  border-left: 1px solid ${COLORS.BORDER};
  border-right: 1px solid ${COLORS.BORDER};
`;

export interface SubconfigurationRowProps extends PropsWithChildren {
  start?: true;
  end?: true;
  target?: true;
}

const SubconfigurationRow: React.FC<SubconfigurationRowProps> = ({
  start,
  end,
  target,
  children,
}) => {
  if (start || end) {
    return (
      <SubconfigurationRowStartOrEndStyled
        $target={target}
        $highlightTop={start}
        $highlightBottom={end}
      >
        {children}
      </SubconfigurationRowStartOrEndStyled>
    );
  }

  return <SubconfigurationRowStyled $target={target}>{children}</SubconfigurationRowStyled>;
};

export default SubconfigurationRow;
